<template>
  <div class="home">
    <!-- <div class="homePage">
      <div class="home-left">
        <div class="left-i">
          <img
            src="~@/assets/icon-home-01.png"
            alt=""
          >
          <p>{{ userInfo.customerCount ? userInfo.customerCount : 0 }}</p>

          <div>客户数量</div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-05.png"
            alt=""
          >
          <p>{{ userInfo.deviceCount ? userInfo.deviceCount : 0 }}</p>

          <div>设备总数 </div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.faultDeviceCount ? userInfo.faultDeviceCount : 0 }}</p>

          <div>故障 </div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.offlineDeviceCount ? userInfo.offlineDeviceCount : 0 }}</p>

          <div>离线数量 </div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.onlineDeviceCount ? userInfo.onlineDeviceCount : 0 }}</p>

          <div>在线数量 </div>
        </div>

        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.pipelineCount ? userInfo.pipelineCount : 0 }}</p>

          <div>管线数量 </div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.normalProtection ? userInfo.normalProtection : 0 }}</p>

          <div>正常保护 </div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.overProtection ? userInfo.overProtection : 0 }}</p>

          <div>过保护 </div>
        </div>
        <div class="left-i">
          <img
            src="~@/assets/icon-home-02.png"
            alt=""
          >
          <p>{{ userInfo.underProtection ? userInfo.underProtection : 0 }}</p>

          <div>欠保护 </div>
        </div>
      </div>
    </div>
    <div class="home_top">
      <a-card :bordered="false">
        <lineChart12 :chartData="chartData"></lineChart12>
      </a-card>
    </div> -->
    <div class="home_tit">
      <img
        src="~@/assets/1.png"
        alt=""
      >
      设备数据
    </div>
    <div class="home_tong">
      <div class="home_i">
        <div class="item" style="cursor: pointer;" @click="$router.push({ path: '/biz' })">
          <div class="item_t">
            <img
              src="~@/assets/3.png"
              alt=""
            >
            客户数量
          </div>
          <div class="item_c">
            {{ userInfo.customerCount ? userInfo.customerCount : 0 }}
          </div>
        </div>
        <div class="item" style="cursor: pointer;" @click="$router.push({ path: '/saifuneng/pipeline' })">
          <div class="item_t">
            <img
              src="~@/assets/5.png"
              alt=""
            >
            管线数量
          </div>
          <div class="item_c">
            {{ userInfo.pipelineCount ? userInfo.pipelineCount : 0 }}
          </div>
        </div>
        <div class="item" style="cursor: pointer;" @click="$router.push({ path: '/saifuneng/device' })">
          <div class="item_t">
            <img
              src="~@/assets/7.png"
              alt=""
            >
            设备数量
          </div>
          <div class="item_c">
            {{ userInfo.deviceCount ? userInfo.deviceCount : 0 }}
          </div>
        </div>
        <div class="item" style="cursor: pointer;" @click="$router.push({ path: '/saifuneng/device', query: { onlineStatus: 1 }})">
          <div class="item_t">
            <img
              src="~@/assets/8.png"
              alt=""
            >
            在线数量
          </div>
          <div class="item_c">
            {{ userInfo.onlineDeviceCount ? userInfo.onlineDeviceCount : 0 }}
          </div>
        </div>
        <div class="item" style="cursor: pointer;" @click="$router.push({ path: '/saifuneng/device', query: { onlineStatus: 0 } })">
          <div class="item_t">
            <img
              src="~@/assets/2.png"
              alt=""
            >
            离线数量
          </div>
          <div class="item_c">
            {{ userInfo.offlineDeviceCount ? userInfo.offlineDeviceCount : 0 }}
          </div>
        </div>
      </div>
      <div class="home_i">
        <div class="item" style="cursor: pointer;" @click="$router.push({ path: '/saifuneng/device' })">
          <div class="item_t">
            <img
              src="~@/assets/4.png"
              alt=""
            >
            设备故障
          </div>
          <div class="item_c">
            {{ userInfo.faultDeviceCount ? userInfo.faultDeviceCount : 0 }}
          </div>
        </div>
        <div class="item" style="cursor: pointer;" @click="$router.push({ path: '/saifuneng/data/saifuneng/devicedata', query: { protectionStatus: 0 } })">
          <div class="item_t">
            <img
              src="~@/assets/10.png"
              alt=""
            >
            正常保护数
          </div>
          <div class="item_c">
            {{ userInfo.normalProtection ? userInfo.normalProtection : 0 }}
          </div>
        </div>

        <div class="item" style="cursor: pointer;" @click="$router.push({ path: '/saifuneng/data/saifuneng/devicedata', query: { protectionStatus: 2 } })">
          <div class="item_t">
            <img
              src="~@/assets/5.png"
              alt=""
            >
            过保护数
          </div>
          <div class="item_c">
            {{ userInfo.overProtection ? userInfo.overProtection : 0 }}
          </div>
        </div>
        <div class="item" style="cursor: pointer;" @click="$router.push({ path: '/saifuneng/data/saifuneng/devicedata', query: { protectionStatus: 1 } })">
          <div class="item_t">
            <img
              src="~@/assets/9.png"
              alt=""
            >
            欠保护数
          </div>
          <div class="item_c">
            {{ userInfo.underProtection ? userInfo.underProtection : 0 }}
          </div>
        </div>
        <div class="item">
          <div class="item_t">
            <img
              src="~@/assets/3.png"
              alt=""
            >
            城市数
          </div>
          <div class="item_c">
            {{ userInfo.cityCount ? userInfo.cityCount : 0 }}
          </div>
        </div>
      </div>
    </div>
    <div class="home_tit">
      <img
        src="~@/assets/1.png"
        alt=""
      >
      城市分布
    </div>
    <div class="chart_line">
      <lineChart12 :chartData="chartData"></lineChart12>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { homeStatistics } from '@/api/home'
import lineChart12 from './Charts/lineChart12.vue'
export default {
  name: 'Wel',
  components: {
    lineChart12
  },
  data () {
    return {
      activeNames: ['1', '2', '3', '4'],
      DATA: [],
      chartData: {},
      text: '',
      actor: '',
      count: 0,
      isText: false,
      userInfo: {},
      devList: [],
      role: ''
    }
  },
  computed: {
    ...mapGetters(['roles'])
  },
  mounted () {

  },
  created () {
    console.log(12121212);
    this.getAddress()
  },
  methods: {
    getAddress () {
      homeStatistics().then(res => {
        console.log(res, '滴滴滴滴滴滴111111============')
        this.userInfo = res.data
        let chart = {
          x: [],
          y: []
        }
        let x = []
        res.data.cityList.forEach(v => {
          console.log(v, '对对对的多多多');
          chart.x.push(v.city)
          chart.y.push(v.deviceCount)
        })
        this.chartData = chart
        console.log(this.chartData, ' this.chartData this.chartData');
      })


    }
  }
}
</script>

<style scoped="scoped" lang="less">
.home {
  background: #fff;
  width: 100%;
  height: 83vh;
  border-radius: 12px;
  padding: 20px 29px 0;

  .home_tit {
    font-weight: bold;
    font-size: 22px;
    color: #333333;
    padding-bottom: 19px;
    border-bottom: 1px solid rgba(112, 112, 112, 0.19);
    display: flex;
    align-items: center;

    img {
      width: 15px;
      height: 15px;
      margin-right: 9px;
    }
  }

  .home_tong {
    padding-top: 27px;

    // display: flex;
    // align-items: center;
    // flex-wrap: wrap;
    // padding-bottom: 38px;
    .home_i {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .item {
      width: 290px;
      height: 103px;
      background: #F8F8F8;
      border-radius: 13px 13px 13px 13px;
      margin-bottom: 14px;
      // margin-right: 33px;
      padding-top: 13px;
      padding-left: 18px;

      &:nth-child(5n) {
        margin-right: 0;
      }


      .item_t {
        margin-bottom: 15px;

        img {
          width: 12px;
          height: 12px;
          margin-right: 12px;
        }

        display: flex;
        align-items: center;
        color: #666;
        font-size: 16px;
      }

      .item_c {
        font-size: 24px;
        color: #333;
        font-weight: 800;
        padding-left: 20px;
      }
    }
  }

  .chart_line {
    margin-top: 40px;
  }

}
</style>
